<!DOCTYPE html>
<html lang="uk">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#09090b">
    <meta name="mobile-web-app-capable" content="yes">
    <meta name="apple-mobile-web-app-capable" content="yes">
    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
    <title>SyncFlow</title>
    <link rel="stylesheet" href="/src/css/index.css">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap">
    <link rel="manifest" href="/manifest.json?v=5">
    <link rel="icon" type="image/png" sizes="32x32" href="/src/images/favicon-32x32-v2.png?v=5">
    <link rel="icon" type="image/png" sizes="16x16" href="/src/images/favicon-16x16-v2.png?v=5">
    <link rel="apple-touch-icon" sizes="180x180" href="/src/images/apple-touch-icon-v2.png?v=5">
    <link rel="shortcut icon" href="/src/images/favicon-32x32-v2.png?v=5">
    <link href="https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css" rel="stylesheet">
    <style>
        body.auth-pending {
            display: none !important;
        }
    </style>
    <!-- Vite handles caching -->
</head>

<body class="auth-pending">
    <div class="app-layout">
        <!-- Sidebar -->
        <aside class="sidebar" id="sidebar">
            <div class="sidebar-header">
                <div class="sidebar-profile" id="sidebar-profile-box" title="Перейти до профілю">
                    <div class="sidebar-avatar" id="sidebar-avatar">
                        <img src="src/images/profile.png" alt="avatar" id="sidebar-avatar-img" onerror="this.onerror=null; this.src='src/images/profile.png';">
                    </div>
                    <div class="sidebar-user-info">
                        <span class="sidebar-username" id="sidebar-username">Користувач</span>
                        <span class="sidebar-role" id="sidebar-role">SyncFlow</span>
                    </div>
                </div>
                <button class="sidebar-toggle" id="sidebar-toggle" data-tooltip="Згорнути" data-tooltip-pos="right">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M11 19l-7-7 7-7M18 19l-7-7 7-7" />
                    </svg>
                </button>
            </div>

            <nav class="sidebar-nav">
                <div class="sidebar-section">
                    <span class="sidebar-section-title">Основне</span>
                    <button class="sidebar-item active" data-tab="dashboard">
                        <i class="ri-layout-grid-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Сьогодні</span>
                    </button>
                    <button class="sidebar-item" data-tab="slots">
                        <i class="ri-timer-flash-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Слоти & Ціль</span>
                    </button>
                    <button class="sidebar-item" data-tab="notes">
                        <i class="ri-book-read-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">База знань</span>
                    </button>
                    <button class="sidebar-item" data-tab="pomodoro">
                        <i class="ri-timer-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Помодоро</span>
                    </button>
                    <button class="sidebar-item" data-tab="tasks">
                        <i class="ri-checkbox-circle-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Завдання</span>
                    </button>
                    <button class="sidebar-item" data-tab="projects">
                        <i class="ri-folder-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Проекти</span>
                    </button>
                    <button class="sidebar-item" data-tab="statistics">
                        <i class="ri-bar-chart-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Статистика</span>
                    </button>
                </div>

                <div class="sidebar-section">
                    <span class="sidebar-section-title">Життя</span>
                    <button class="sidebar-item" data-tab="goals">
                        <i class="ri-focus-3-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Цілі</span>
                    </button>
                    <button class="sidebar-item" data-tab="habits" onclick="switchTab('habits')">
                        <i class="ri-calendar-check-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Звички</span>
                    </button>
                    <button class="sidebar-item" data-tab="finances">
                        <i class="ri-wallet-3-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Фінанси</span>
                    </button>
                    <button class="sidebar-item" data-tab="training">
                        <i class="ri-run-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Тренування</span>
                    </button>
                    <button class="sidebar-item" data-tab="youtube">
                        <i class="ri-youtube-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">YouTube</span>
                    </button>
                    <button class="sidebar-item" data-tab="photo-reports">
                        <i class="ri-gallery-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Фотозвіти</span>
                    </button>
                </div>

                <div class="sidebar-section">
                    <span class="sidebar-section-title">Розширення & Система</span>
                    <button class="sidebar-item" data-tab="egds">
                        <i class="ri-plug-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Модуль eGDS</span>
                    </button>
                    <button class="sidebar-item" data-tab="profile">
                        <i class="ri-user-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Профіль</span>
                    </button>
                    <button class="sidebar-item" data-tab="security">
                        <i class="ri-shield-keyhole-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Безпека</span>
                    </button>
                    <button class="sidebar-item" data-tab="settings">
                        <i class="ri-settings-4-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Налаштування</span>
                    </button>
                </div>
            </nav>
        </aside>

        <!-- Main Content -->
        <main class="main-content">
            <div id="message-container" class="message-container is-hidden"></div>

            <div class="tab-container">
                <!-- Page Header (показується для кожної вкладки) -->
                <header class="page-header">
                    <div class="page-header-left">
                        <span class="page-breadcrumb" id="page-breadcrumb">SyncFlow</span>
                        <h1 class="page-title" id="page-title"><i class="ri-calendar-event-line sub-tab-icon"></i><span>Сьогодні</span></h1>
                    </div>
                    <div class="page-header-right">
                        <button class="btn-quick-capture-pill" id="btn-quick-capture" title="Швидкі дії (Ctrl + K)">
                            <i class="ri-command-line"></i>
                            <span class="cmd-kbd-hint">Ctrl K</span>
                        </button>
                        <div class="page-search search-container">
                            <i class="ri-search-line page-search-icon"></i>
                            <input type="text"
                                style="position: absolute; width: 0; height: 0; padding: 0; margin: 0; border: none; overflow: hidden;"
                                aria-hidden="true" autocomplete="username">
                            <input type="password"
                                style="position: absolute; width: 0; height: 0; padding: 0; margin: 0; border: none; overflow: hidden;"
                                aria-hidden="true" autocomplete="current-password">
                            <input type="search" placeholder="Пошук..." id="page-search-input" name="search-page-query"
                                data-tooltip="Гаряча клавіша: F"
                                autocomplete="new-password" autocorrect="off" spellcheck="false">
                            <button class="search-clear" id="page-search-clear" style="display: none;">
                                <i class="ri-close-line"></i>
                            </button>
                        </div>
                        <span class="search-results-count" id="search-results-count"></span>
                    </div>
                </header>

                <!-- Functional Tabs -->
                <div class="tab-content">
                    <div class="tab-panel active" id="dashboard">
                        <div class="tab-panel-header dashboard-panel-header">
                            <div class="dashboard-header-left">
                                <h1 class="dashboard-greeting" id="dashboard-greeting">Доброго дня! 👋</h1>
                                <span class="dashboard-date" id="dashboard-date">Завантаження дати...</span>
                            </div>
                            <div class="tab-header-right">
                                <div class="dashboard-quick-actions">
                                    <button class="btn btn-primary" id="dash-btn-add-task">
                                        <i class="ri-add-line"></i> Нове завдання
                                    </button>
                                    <button class="btn btn-secondary" id="dash-btn-add-expense">
                                        <i class="ri-wallet-3-line"></i> Додати витрату
                                    </button>
                                    <button class="btn btn-secondary" id="dash-btn-add-goal">
                                        <i class="ri-focus-3-line"></i> Нова ціль
                                    </button>
                                    <button class="btn btn-secondary btn-icon" id="dash-btn-widget-settings" title="Налаштування віджетів дашборду">
                                        <i class="ri-settings-3-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Daily Motivational Quote -->
                        <div class="dashboard-quote-card" id="dashboard-quote-card">
                            <div class="quote-icon-box">
                                <i class="ri-lightbulb-flash-line"></i>
                            </div>
                            <div class="quote-text-container">
                                <p class="quote-content-text" id="dashboard-quote-text">"Завжди здається неможливим, поки це не зроблено."</p>
                                <span class="quote-author-name" id="dashboard-quote-author">— Нельсон Мандела</span>
                            </div>
                        </div>

                        <!-- KPI Summary Cards -->
                        <div class="dashboard-kpi-grid">
                            <div class="kpi-card" data-tab-target="tasks">
                                <div class="kpi-icon kpi-icon-blue">
                                    <i class="ri-checkbox-circle-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Завдання на сьогодні</span>
                                    <span class="kpi-value" id="dash-kpi-today-tasks">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-total-active-tasks">Всього активних: 0</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="projects">
                                <div class="kpi-icon kpi-icon-purple">
                                    <i class="ri-folder-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Активні проєкти</span>
                                    <span class="kpi-value" id="dash-kpi-active-projects">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-total-projects">Всього проєктів: 0</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="finances">
                                <div class="kpi-icon kpi-icon-green">
                                    <i class="ri-wallet-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Баланс місяця</span>
                                    <span class="kpi-value" id="dash-kpi-finance-balance">0 ₴</span>
                                    <span class="kpi-subtext" id="dash-kpi-finance-subtext">Доходи: 0 ₴ | Витрати: 0 ₴</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="goals">
                                <div class="kpi-icon kpi-icon-orange">
                                    <i class="ri-focus-3-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Активні цілі</span>
                                    <span class="kpi-value" id="dash-kpi-active-goals">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-goals-progress">Сер. прогрес: 0%</span>
                                </div>
                            </div>
                        </div>

                        <!-- Dashboard Widgets Grid -->
                        <div class="dashboard-content-grid">
                            <!-- Left Main Column -->
                            <div class="dashboard-col main-col">
                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-calendar-check-line"></i> Завдання на сьогодні та фокус</h3>
                                        <div class="dash-widget-header-right">
                                            <button class="dash-widget-btn-add" id="dash-btn-add-task"><i class="ri-add-line"></i> Додати</button>
                                            <button class="dash-widget-action" data-tab-target="tasks">Усі завдання <i class="ri-arrow-right-line"></i></button>
                                        </div>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div id="dash-today-tasks-list" class="dash-task-list">
                                            <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження завдань...</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-rocket-line"></i> Активні проєкти</h3>
                                        <div class="dash-widget-header-right">
                                            <button class="dash-widget-btn-add" id="dash-btn-add-project"><i class="ri-add-line"></i> Новий проєкт</button>
                                            <button class="dash-widget-action" data-tab-target="projects">Усі проєкти <i class="ri-arrow-right-line"></i></button>
                                        </div>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div id="dash-active-projects-list" class="dash-projects-grid">
                                            <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження проєктів...</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Side Column -->
                            <div class="dashboard-col side-col">
                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-timer-flash-line"></i> Швидкий секундомір & таймер</h3>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div class="standalone-timer-box">
                                            <div class="timer-mode-switcher">
                                                <button type="button" class="timer-mode-btn active" id="timer-mode-stopwatch"><i class="ri-time-line"></i> Секундомір</button>
                                                <button type="button" class="timer-mode-btn" id="timer-mode-countdown"><i class="ri-alarm-warning-line"></i> Відлік</button>
                                            </div>

                                            <div class="standalone-timer-display" id="standalone-timer-display">00:00:00</div>

                                            <div class="custom-timer-input-group" id="custom-timer-input-group" style="display: none;">
                                                <div class="custom-timer-inputs">
                                                    <div class="custom-input-unit">
                                                        <input type="number" id="custom-timer-hrs" min="0" max="99" value="00" class="custom-timer-input">
                                                        <span class="custom-unit-label">год</span>
                                                    </div>
                                                    <span class="custom-sep">:</span>
                                                    <div class="custom-input-unit">
                                                        <input type="number" id="custom-timer-mins" min="0" max="59" value="25" class="custom-timer-input">
                                                        <span class="custom-unit-label">хв</span>
                                                    </div>
                                                    <span class="custom-sep">:</span>
                                                    <div class="custom-input-unit">
                                                        <input type="number" id="custom-timer-secs" min="0" max="59" value="00" class="custom-timer-input">
                                                        <span class="custom-unit-label">сек</span>
                                                    </div>
                                                </div>
                                                <button type="button" class="preset-time-btn active" id="custom-timer-apply" title="Застосувати">
                                                    <i class="ri-check-line"></i> Готово
                                                </button>
                                            </div>

                                            <div class="countdown-presets" id="countdown-presets" style="display: none;">
                                                <button type="button" class="preset-time-btn" data-mins="5">5хв</button>
                                                <button type="button" class="preset-time-btn" data-mins="15">15хв</button>
                                                <button type="button" class="preset-time-btn active" data-mins="25">25хв</button>
                                                <button type="button" class="preset-time-btn" data-mins="45">45хв</button>
                                                <button type="button" class="preset-time-btn" data-mins="60">60хв</button>
                                                <button type="button" class="preset-time-btn custom-preset-btn" id="custom-timer-toggle-btn" title="Вказати власний час"><i class="ri-edit-line"></i> Свій</button>
                                            </div>

                                            <div class="standalone-timer-controls">
                                                <button type="button" class="standalone-timer-btn btn-start" id="standalone-timer-start">
                                                    <i class="ri-play-fill"></i> Старт
                                                </button>
                                                <button type="button" class="standalone-timer-btn btn-pause" id="standalone-timer-pause" style="display: none;">
                                                    <i class="ri-pause-fill"></i> Пауза
                                                </button>
                                                <button type="button" class="standalone-timer-btn btn-lap" id="standalone-timer-lap" style="display: none;">
                                                    <i class="ri-flag-2-line"></i> Коло
                                                </button>
                                                <button type="button" class="standalone-timer-btn btn-reset" id="standalone-timer-reset">
                                                    <i class="ri-refresh-line"></i> Скинути
                                                </button>
                                            </div>

                                            <div class="timer-laps-container" id="timer-laps-container" style="display: none;">
                                                <div class="timer-laps-list" id="timer-laps-list"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-pie-chart-line"></i> Фінансовий підсумок місяця</h3>
                                        <div class="dash-widget-header-right">
                                            <button class="dash-widget-btn-add" id="dash-btn-add-expense"><i class="ri-wallet-3-line"></i> Витрата</button>
                                            <button class="dash-widget-action" data-tab-target="finances">Фінанси <i class="ri-arrow-right-line"></i></button>
                                        </div>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div id="dash-finances-summary" class="dash-finance-box">
                                            <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-trophy-line"></i> Поточні цілі</h3>
                                        <div class="dash-widget-header-right">
                                            <button class="dash-widget-btn-add" id="dash-btn-add-goal"><i class="ri-focus-3-line"></i> Нова ціль</button>
                                            <button class="dash-widget-action" data-tab-target="goals">Усі цілі <i class="ri-arrow-right-line"></i></button>
                                        </div>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div id="dash-goals-list" class="dash-goals-list">
                                            <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dash-widget">
                                    <div class="dash-widget-header">
                                        <h3><i class="ri-run-line"></i> Останні тренування</h3>
                                        <div class="dash-widget-header-right">
                                            <button class="dash-widget-btn-add" id="dash-btn-add-training"><i class="ri-add-line"></i> Тренування</button>
                                            <button class="dash-widget-action" data-tab-target="training">Детальніше <i class="ri-arrow-right-line"></i></button>
                                        </div>
                                    </div>
                                    <div class="dash-widget-body">
                                        <div id="dash-training-summary" class="dash-training-box">
                                            <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dashboard-bottom-spacer"></div>
                    </div>

                    <!-- SLOTS & FINANCIAL 40K TARGET TAB -->
                    <div class="tab-panel" id="slots">
                        <div class="tab-panel-header" style="margin-bottom: 20px;">
                            <div class="slots-header-info">
                                <h2 class="slots-header-title"><i class="ri-timer-flash-line" style="color:var(--brand-orange);"></i> Система Слотів & Фінансова Ціль</h2>
                                <span class="slots-header-sub">Планка: <strong>40 000+ грн/міс</strong> · Доставка: <strong>20.0 год/тижд</strong> · Залізне вікно сну: <strong>00:00 – 09:00</strong></span>
                            </div>
                            <div class="tab-header-right">
                                <button class="btn btn-secondary" onclick="refreshSlotsData()"><i class="ri-refresh-line"></i> Оновити</button>
                            </div>
                        </div>

                        <!-- Live Active Slot Banner -->
                        <div class="slots-live-card">
                            <div class="slots-live-left">
                                <i id="slots-live-icon" class="ri-time-line slots-live-icon"></i>
                                <div>
                                    <span class="slots-live-label">Поточний слот зараз</span>
                                    <h3 id="slots-live-title" class="slots-live-title">Завантаження розкладу...</h3>
                                    <p id="slots-live-desc" class="slots-live-desc"></p>
                                </div>
                            </div>
                            <div class="slots-live-right">
                                <span id="slots-live-countdown" class="slots-live-countdown"></span>
                            </div>
                        </div>

                        <!-- Operational Metric Cards Grid -->
                        <div class="slots-grid">
                            <!-- Card 1: Delivery Quota & Weekend Buffer -->
                            <div class="slots-card">
                                <div class="slots-card-header">
                                    <h3><i class="ri-riding-line" style="color:var(--brand-orange);"></i> Доставка (Glovo + Bolt)</h3>
                                    <span id="slots-week-status-badge" class="slots-badge badge-info">...</span>
                                </div>
                                <div class="slots-card-body">
                                    <div class="slots-metric-row">
                                        <span class="slots-metric-label">Тижневий норматив</span>
                                        <span class="slots-metric-val"><span id="slots-week-hours">0.0 год</span> <small id="slots-week-quota">/ 20 год</small></span>
                                    </div>
                                    <div class="slots-progress-bar">
                                        <div id="slots-week-progress-fill" class="slots-progress-fill" style="width:0%"></div>
                                    </div>
                                    <div class="slots-submetrics">
                                        <div class="slots-submetric-item">
                                            <span>Заробіток тижня</span>
                                            <strong id="slots-week-earnings">0 грн</strong>
                                        </div>
                                        <div class="slots-submetric-item">
                                            <span>Середня ставка</span>
                                            <strong id="slots-week-rate">0 грн/год</strong>
                                        </div>
                                    </div>
                                    <div class="slots-buffer-hint">
                                        <i class="ri-information-line"></i>
                                        <span>Недобір у будні автоматично йде в буфер СБ/НД (піки 13:00–17:00 / 18:00–22:00).</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 2: 40 000 UAH Monthly Target -->
                            <div class="slots-card">
                                <div class="slots-card-header">
                                    <h3><i class="ri-money-dollar-circle-line" style="color:var(--color-success);"></i> Фінансова планка місяця</h3>
                                    <span id="slots-month-remaining" class="slots-metric-hint">Розрахунок...</span>
                                </div>
                                <div class="slots-card-body">
                                    <div class="slots-metric-row">
                                        <span class="slots-metric-label">Загальний дохід місяця</span>
                                        <span class="slots-metric-val"><strong id="slots-month-total" style="color:var(--color-success);">0 грн</strong> <small id="slots-month-target">/ 40 000 грн</small></span>
                                    </div>
                                    <div class="slots-progress-bar">
                                        <div id="slots-month-fill" class="slots-progress-fill fill-green" style="width:0%"></div>
                                    </div>
                                    <div class="slots-breakdown-list">
                                        <div class="slots-breakdown-item">
                                            <span><i class="ri-book-read-line"></i> Ліцей (інклюзія)</span>
                                            <strong id="slots-month-school">~15 500 грн</strong>
                                        </div>
                                        <div class="slots-breakdown-item">
                                            <span><i class="ri-macbook-line"></i> ПУМ (технік)</span>
                                            <strong id="slots-month-pum">~6 000 грн</strong>
                                        </div>
                                        <div class="slots-breakdown-item">
                                            <span><i class="ri-riding-line"></i> Доставка (накопичено)</span>
                                            <strong id="slots-month-delivery" style="color:var(--brand-orange);">0 грн</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 3: Daily Time Balance & Sleep -->
                            <div class="slots-card">
                                <div class="slots-card-header">
                                    <h3><i class="ri-heart-pulse-line" style="color:#8b5cf6;"></i> Баланс доби & Відновлення</h3>
                                    <span class="slots-badge badge-purple">9 год сну</span>
                                </div>
                                <div class="slots-card-body">
                                    <div class="slots-pie-summary">
                                        <div class="slots-pie-item">
                                            <span class="dot" style="background:#ef4444;"></span>
                                            <span>Чиста робота: <strong>10.0 год</strong></span>
                                        </div>
                                        <div class="slots-pie-item">
                                            <span class="dot" style="background:#64748b;"></span>
                                            <span>Логістика / обід: <strong>2.0 год</strong></span>
                                        </div>
                                        <div class="slots-pie-item">
                                            <span class="dot" style="background:#3b82f6;"></span>
                                            <span>Вільний час: <strong>3.0 год</strong></span>
                                        </div>
                                        <div class="slots-pie-item">
                                            <span class="dot" style="background:#8b5cf6;"></span>
                                            <span>Залізне вікно сну: <strong>9.0 год</strong></span>
                                        </div>
                                    </div>
                                    <div class="slots-sleep-rule">
                                        <i class="ri-shield-star-line"></i>
                                        <span><strong>Залізне правило:</strong> 00:00–09:00 недоторканні. Жодних компромісів зі сном.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Daily Report Form & History Table -->
                        <div class="slots-bottom-grid">
                            <!-- Daily Report Form -->
                            <div class="slots-card">
                                <div class="slots-card-header">
                                    <h3><i class="ri-edit-circle-line"></i> Фіксація звітного дня</h3>
                                    <span style="font-size:12px;color:var(--text-muted);">Заповніть у вікні 22:30–00:00</span>
                                </div>
                                <div class="slots-card-body">
                                    <div class="slots-form-grid">
                                        <div class="slots-form-group">
                                            <label>Дата звіту</label>
                                            <input type="date" id="slot-input-date" class="slots-input">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>ПУМ (год)</label>
                                            <input type="number" step="0.5" id="slot-input-pum" class="slots-input" value="1.5">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Школа / Ліцей (год)</label>
                                            <input type="number" step="0.5" id="slot-input-school" class="slots-input" value="4.5">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Доставка (год)</label>
                                            <input type="number" step="0.5" id="slot-input-delivery-hours" class="slots-input" value="4.0">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Заробіток доставки (грн)</label>
                                            <input type="number" step="10" id="slot-input-delivery-earnings" class="slots-input" placeholder="наприклад 880">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Примітки (необов'язково)</label>
                                            <input type="text" id="slot-input-notes" class="slots-input" placeholder="педрада, дощ тощо">
                                        </div>
                                    </div>
                                    <div class="slots-form-row-check">
                                        <label class="slots-checkbox-label">
                                            <input type="checkbox" id="slot-input-sleep" checked>
                                            <span>Залізне вікно сну (00:00 – 09:00) дотримано (без зривів)</span>
                                        </label>
                                    </div>
                                    <div class="slots-form-actions">
                                        <button class="btn btn-primary" onclick="saveSlotsDailyReport()">
                                            <i class="ri-save-line"></i> Зберегти звіт дня
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- History Table -->
                            <div class="slots-card">
                                <div class="slots-card-header">
                                    <h3><i class="ri-history-line"></i> Історія слотів (останні 14 днів)</h3>
                                </div>
                                <div class="slots-card-body" style="overflow-x:auto;">
                                    <table class="slots-table">
                                        <thead>
                                            <tr>
                                                <th>Дата</th>
                                                <th>ПУМ</th>
                                                <th>Школа</th>
                                                <th>Доставка</th>
                                                <th>Заробіток</th>
                                                <th>Рейт</th>
                                                <th>Сон</th>
                                            </tr>
                                        </thead>
                                        <tbody id="slots-history-tbody">
                                            <tr><td colspan="7" style="text-align:center;padding:20px;">Завантаження історії...</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="dashboard-bottom-spacer"></div>
                    </div>

                    <div class="tab-panel" id="tasks">
<div class="tab-panel-header">
                                                        <button class="sub-tab-button active" data-sub-tab="tasks-list">
                                <i class="ri-checkbox-circle-line sub-tab-icon"></i>
                                <span>Активні завдання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="today-tasks">
                                <i class="ri-calendar-event-line sub-tab-icon"></i>
                                <span>Сьогодні</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="active-tasks">
                                <i class="ri-timer-line sub-tab-icon"></i>
                                <span>Активні таймери</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="no-date-tasks">
                                <i class="ri-calendar-close-line sub-tab-icon"></i>
                                <span>Без дати</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-archive">
                                <i class="ri-archive-line sub-tab-icon"></i>
                                <span>Архів</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-all">
                                <i class="ri-list-unordered sub-tab-icon"></i>
                                <span>Всі завдання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-calendar">
                                <i class="ri-calendar-line sub-tab-icon"></i>
                                <span>Календар</span>
                            </button>

                            <div class="tab-header-right">
                                <button class="tasks-smart-sort-toggle" id="tasks-smart-sort-toggle" type="button"
                                    aria-pressed="false" title="Прострочені → Сьогодні → Решта">
                                    <i class="ri-magic-line"></i>
                                    <span>Розумне сортування</span>
                                </button>

                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>

                                <div class="data-table-bulk-actions" style="display: none;">
                                    <div class="task-bulk-more">
                                        <button class="task-bulk-more-toggle" type="button"
                                            aria-label="Масові дії для вибраних">
                                            <i class="ri-settings-4-line"></i>
                                            <span>Масові дії</span>
                                            <i class="ri-arrow-down-s-line"></i>
                                        </button>
                                        <div class="task-bulk-more-menu">
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="category"
                                                aria-label="Змінити категорію для вибраних">
                                                <i class="ri-price-tag-3-line"></i>
                                                <span>Категорія</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="date"
                                                aria-label="Змінити дату для вибраних">
                                                <i class="ri-calendar-line"></i>
                                                <span>Дата</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="period"
                                                aria-label="Змінити період для вибраних">
                                                <i class="ri-time-line"></i>
                                                <span>Період</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="limit"
                                                aria-label="Змінити ліміт для вибраних">
                                                <i class="ri-timer-line"></i>
                                                <span>Ліміт</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="archive"
                                                aria-label="Архівувати вибрані">
                                                <i class="ri-archive-line"></i>
                                                <span>Архів</span>
                                            </button>
                                        </div>
                                    </div>
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <!-- Add/Edit form replaced by modals at the bottom of the body -->
                        <div class="sub-tab-content">
                            <!-- Helper for repeated tables -->
                            <div class="sub-tab-panel active" id="tasks-list-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-archive-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-archive-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="active-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="active-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="today-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="today-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="no-date-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="no-date-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-all-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-all-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-calendar-content">
                                <h3 id="calendar-month-label"
                                    style="text-align: center; color: var(--text-title); margin-bottom: 20px;"></h3>
                                <div class="kanban-container" id="tasks-calendar-grid">
                                    <!-- Calendar Grid generated by JS -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="projects">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="projects-active">
                                <i class="ri-list-check sub-tab-icon"></i>
                                <span>Активні проекти</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="projects-active-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox" class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="name">
                                                    <span class="th-label">Назва</span>
                                                </th>
                                                <th class="col-status sortable" data-sort="status">
                                                    <span class="th-label">Статус</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-date sortable" data-sort="created_at">
                                                    <span class="th-label">Дата</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="projects-active-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="settings">
<div class="tab-panel-header">
                            <div class="tab-header-right"></div>
                    </div>
                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="settings-main-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-name">Параметр</th>
                                                <th class="col-value">Значення</th>
                                                <th class="col-date">Оновлено</th>
                                            </tr>
                                        </thead>
                                        <tbody id="settings-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="statistics">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="stats-general">
                                <i class="ri-dashboard-3-line sub-tab-icon"></i>
                                <span>Загальне</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="stats-training">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Тренування</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="stats-egds">
                                <i class="ri-shopping-bag-3-line sub-tab-icon"></i>
                                <span>eGDS</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="stats-youtube">
                                <i class="ri-youtube-line sub-tab-icon"></i>
                                <span>YouTube</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="statistics-period-switch" id="statistics-period-switch">
                                    <button class="stats-period-btn active" data-period="7d">7 днів</button>
                                    <button class="stats-period-btn" data-period="30d">30 днів</button>
                                    <button class="stats-period-btn" data-period="12m">12 міс</button>
                                    <button class="stats-period-btn" data-period="year">Рік</button>
                                    <button class="stats-period-btn" data-period="all">All</button>
                                </div>
                                <button class="stats-refresh-btn" id="statistics-refresh-btn" title="Оновити статистику">
                                    <i class="ri-refresh-line"></i>
                                    <span>Оновити</span>
                                </button>
                            </div>
                    </div>
                        <div class="statistics-dashboard" id="statistics-dashboard">
                            <!-- Підвкладка: Загальне -->
                            <div class="sub-tab-panel active" id="stats-general-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">KPI</h3>
                                    <div class="statistics-kpi-grid">
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Доходи</div>
                                            <div class="stats-kpi-value" id="stats-kpi-incomes">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Витрати</div>
                                            <div class="stats-kpi-value" id="stats-kpi-expenses">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Чистий баланс</div>
                                            <div class="stats-kpi-value" id="stats-kpi-net">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Задачі виконано</div>
                                            <div class="stats-kpi-value" id="stats-kpi-tasks">0 / 0</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Тренування</div>
                                            <div class="stats-kpi-value" id="stats-kpi-training">0</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Продажі eGDS</div>
                                            <div class="stats-kpi-value" id="stats-kpi-sales">0.00 ₴</div>
                                        </article>
                                    </div>
                                </section>

                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Фінанси</h3>
                                    <div class="statistics-charts-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Доходи vs витрати</h4>
                                            <div class="stats-chart-body" id="stats-chart-cashflow"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Витрати по категоріях</h4>
                                            <div class="stats-chart-body" id="stats-chart-expenses-categories"></div>
                                        </article>
                                    </div>
                                </section>

                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Цілі</h3>
                                    <div class="statistics-secondary-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Цілі: середній прогрес</h4>
                                            <div class="stats-big-percent" id="stats-goals-avg-progress">0%</div>
                                            <div class="stats-list" id="stats-goals-risk-list"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>

                            <!-- Підвкладка: Тренування -->
                            <div class="sub-tab-panel" id="stats-training-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Тренування та Продуктивність</h3>
                                    <div class="statistics-charts-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Тренування: сесії та тривалість</h4>
                                            <div class="stats-chart-body" id="stats-chart-training"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <div class="stats-card-head">
                                                <h4 class="stats-chart-title">Прогресія тренувань (мотивація)</h4>
                                                <div class="stats-mini-switch" id="stats-training-progression-switch">
                                                    <button class="stats-mini-btn active" data-scale="month">Місяць</button>
                                                    <button class="stats-mini-btn" data-scale="year">Рік</button>
                                                </div>
                                            </div>
                                            <div class="stats-chart-body" id="stats-chart-training-progression"></div>
                                        </article>
                                    </div>
                                    <div class="statistics-secondary-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">План vs факт по таймерах задач</h4>
                                            <div class="stats-metric-inline">
                                                <span>План:</span>
                                                <strong id="stats-plan-minutes">0 хв</strong>
                                            </div>
                                            <div class="stats-metric-inline">
                                                <span>Факт:</span>
                                                <strong id="stats-fact-minutes">0 хв</strong>
                                            </div>
                                            <div class="stats-progress-wrap">
                                                <div class="stats-progress-bar" id="stats-plan-fact-progress"></div>
                                            </div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Виконані задачі по днях тижня</h4>
                                            <div class="stats-chart-body" id="stats-chart-tasks-weekday"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>

                            <!-- Підвкладка: eGDS -->
                            <div class="sub-tab-panel" id="stats-egds-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Бізнес та eGDS</h3>
                                    <div class="statistics-charts-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Замовлення по статусах</h4>
                                            <div class="stats-chart-body" id="stats-chart-orders-status"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Проєкти по статусах</h4>
                                            <div class="stats-chart-body" id="stats-chart-projects-status"></div>
                                        </article>
                                    </div>
                                    <div class="statistics-secondary-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Товари з низьким залишком</h4>
                                            <div class="stats-list" id="stats-low-stock-list"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Топ категорії товарів</h4>
                                            <div class="stats-list" id="stats-top-categories-list"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>

                            <!-- Підвкладка: YouTube -->
                            <div class="sub-tab-panel" id="stats-youtube-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">YouTube Аналітика</h3>
                                    <div class="statistics-charts-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">YouTube: динаміка публікацій</h4>
                                            <div class="stats-chart-body" id="stats-chart-youtube-published"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">YouTube: топ за переглядами</h4>
                                            <div class="stats-list" id="stats-youtube-top-list"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="finances">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="bank">
                                <i class="ri-bank-line sub-tab-icon"></i>
                                <span>Рахунки</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="incomes">
                                <i class="ri-add-circle-line sub-tab-icon"></i>
                                <span>Доходи</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="expenses">
                                <i class="ri-wallet-3-line sub-tab-icon"></i>
                                <span>Витрати</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="bank-content">
                                <div class="add-bank-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Новий рахунок</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-name">Назва</label>
                                                <input type="text" id="bank-name" placeholder="Назва рахунку..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-balance">Баланс</label>
                                                <input type="number" id="bank-balance" placeholder="0.00" step="0.01">
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-currency">Валюта</label>
                                                <input type="text" id="bank-currency" placeholder="UAH" maxlength="10"
                                                    value="UAH">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-description">Опис</label>
                                                <input type="text" id="bank-description" placeholder="Опис..."
                                                    maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Готово" onclick="saveBank()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelBankPanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="edit-bank-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Редагування рахунку</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-name">Назва</label>
                                                <input type="text" id="edit-bank-name" placeholder="Назва рахунку..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-balance">Баланс</label>
                                                <input type="number" id="edit-bank-balance" placeholder="0.00"
                                                    step="0.01">
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-currency">Валюта</label>
                                                <input type="text" id="edit-bank-currency" placeholder="UAH"
                                                    maxlength="10">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-description">Опис</label>
                                                <input type="text" id="edit-bank-description" placeholder="Опис..."
                                                    maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="updateBank()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelEditBankPanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="name">
                                                    <span class="th-label">Назва</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-balance sortable" data-sort="balance">
                                                    <span class="th-label">Баланс</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-description">Опис</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="bank-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="incomes-content">
                                <div class="add-income-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Новий дохід</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-source">Джерело</label>
                                                <input type="text" id="income-source" placeholder="Напр. Зарплата..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-amount">Сума</label>
                                                <input type="number" id="income-amount" placeholder="0.00" step="0.01">
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-currency">Валюта</label>
                                                <input type="text" id="income-currency" placeholder="UAH" maxlength="10"
                                                    value="UAH">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-category">Категорія</label>
                                                <input type="text" id="income-category" placeholder="Напр. Робота..."
                                                    maxlength="100">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-description">Опис</label>
                                                <input type="text" id="income-description"
                                                    placeholder="Додаткова інформація..." maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Готово" onclick="saveIncome()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelIncomePanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="edit-income-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Редагування доходу</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-source">Джерело</label>
                                                <input type="text" id="edit-income-source"
                                                    placeholder="Напр. Зарплата..." maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-amount">Сума</label>
                                                <input type="number" id="edit-income-amount" placeholder="0.00"
                                                    step="0.01">
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-currency">Валюта</label>
                                                <input type="text" id="edit-income-currency" placeholder="UAH"
                                                    maxlength="10">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-category">Категорія</label>
                                                <input type="text" id="edit-income-category"
                                                    placeholder="Напр. Робота..." maxlength="100">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-description">Опис</label>
                                                <input type="text" id="edit-income-description"
                                                    placeholder="Додаткова інформація..." maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="updateIncome()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelEditIncomePanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="source">
                                                    <span class="th-label">Джерело</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-amount sortable" data-sort="amount">
                                                    <span class="th-label">Сума</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-category">Категорія</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="incomes-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="expenses-content">
                                <!-- Budget Status Widget -->
                                <div class="budget-status-card" style="background: var(--bg-surface); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); padding: 16px 20px; margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between; gap: 20px;">
                                    <div style="display: flex; align-items: center; gap: 14px;">
                                        <div style="width: 42px; height: 42px; border-radius: 10px; background: rgba(59, 130, 246, 0.15); color: #3b82f6; display: flex; align-items: center; justify-content: center; font-size: 20px;">
                                            <i class="ri-pie-chart-2-line"></i>
                                        </div>
                                        <div>
                                            <div style="font-size: 14px; font-weight: 600; color: var(--text-title);">Місячний бюджет витрат</div>
                                            <div style="font-size: 12px; color: var(--text-muted); margin-top: 2px;">
                                                Витрачено у цьому місяці: <strong id="budget-spent-amount" style="color: var(--text-title);">0 ₴</strong> з <span id="budget-total-limit">50,000 ₴</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="flex: 1; max-width: 280px;">
                                        <div style="display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 4px; color: var(--text-dim);">
                                            <span>Використано</span>
                                            <span id="budget-percentage-text">0%</span>
                                        </div>
                                        <div style="height: 8px; background: rgba(255,255,255,0.08); border-radius: 4px; overflow: hidden;">
                                            <div id="budget-progress-bar" style="width: 0%; height: 100%; background: #10b981; transition: width 0.4s ease, background 0.3s ease;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-date sortable" data-sort="date">
                                                    <span class="th-label">Дата</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-category sortable" data-sort="expense_type">
                                                    <span class="th-label">Тип витрати</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-name"><span class="th-label">Магазин</span></th>
                                                <th class="col-amount sortable" data-sort="amount">
                                                    <span class="th-label">Сума</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="expenses-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ===== ВКЛАДКА ТРЕНУВАННЯ ===== -->
                    <div class="tab-panel" id="training">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="running">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Біг</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="pullups">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Підтягування</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="pushups">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Віджимання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="training-history">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Історія</span>
                            </button>
                            <div class="tab-header-right">
                                <button class="btn btn-secondary btn-sm" id="btn-workout-preset" style="display: inline-flex; align-items: center; gap: 6px;">
                                    <i class="ri-flashlight-line"></i> Шаблон тренування
                                </button>
                            </div>
                    </div>


                        <div class="sub-tab-content">
                    <!-- Підвкладка: Біг -->
                    <div class="sub-tab-panel active" id="running-content">
                        <div class="training-section">
                            <div class="training-info">
                                <div class="training-week">
                                    <span class="training-label">Тиждень:</span>
                                    <span class="training-value" id="training-current-week">1</span>
                                </div>
                                <div class="training-duration">
                                    <span class="training-label">Час бігу:</span>
                                    <span class="training-value" id="training-run-duration">20 хв</span>
                                </div>
                            </div>
                            <div class="training-plan-card">
                                <div class="training-plan-title">План бігу</div>
                                <div class="training-plan-note" id="running-plan-note">Базово 20 хв, +1 хв щотижня</div>
                                <div class="training-week-status" id="running-week-status"></div>
                            </div>

                            <div class="training-timer">
                                <div class="timer-display" id="run-timer-display">00:00:00</div>
                                <div class="timer-controls">
                                    <button class="btn-timer btn-start" id="run-timer-start" onclick="startRunTimer()">
                                        <span>▶</span> Старт
                                    </button>
                                    <button class="btn-timer btn-pause" id="run-timer-pause" onclick="pauseRunTimer()"
                                        style="display: none;">
                                        <span>⏸</span> Пауза
                                    </button>
                                    <button class="btn-timer btn-resume" id="run-timer-resume"
                                        onclick="resumeRunTimer()" style="display: none;">
                                        <span>▶</span> Продовжити
                                    </button>
                                    <button class="btn-timer btn-stop" id="run-timer-stop" onclick="stopRunTimer()"
                                        style="display: none;">
                                        <span>⏹</span> Завершити
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="running-today-sessions">
                                <!-- Сесії бігу за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Підтягування -->
                    <div class="sub-tab-panel" id="pullups-content">
                        <div class="training-section">
                            <div class="training-plan-card">
                                <div class="training-plan-title">План підтягувань (5 підходів)</div>
                                <div class="training-plan-sets" id="pullups-plan-sets"></div>
                                <div class="training-plan-note" id="pullups-plan-note"></div>
                                <div class="training-plan-progress" id="pullups-plan-progress"></div>
                                <div class="training-week-status" id="pullups-week-status"></div>
                            </div>
                            <div class="training-sets-form">
                                <h3 class="training-form-title">Новий підхід</h3>
                                <div class="training-form-row">
                                    <div class="training-form-group">
                                        <label class="field-label" for="pullups-reps">Кількість повторів</label>
                                        <input type="number" id="pullups-reps" min="1" max="100" placeholder="0">
                                    </div>
                                    <button class="btn-add-set" onclick="addSet('pullups')">+ Додати підхід</button>
                                    <button class="btn-add-set btn-add-set-plan" onclick="addNextPlannedSet('pullups')">+ Додати за планом</button>
                                </div>
                            </div>

                            <div class="training-current-session" id="pullups-current-session">
                                <h3 class="training-form-title">Поточна сесія</h3>
                                <div class="training-sets-list" id="pullups-sets-list">
                                    <!-- Підходи поточної сесії -->
                                </div>
                                <div class="training-session-actions" id="pullups-session-actions"
                                    style="display: none;">
                                    <button class="btn-timer btn-stop" onclick="finishSession('pullups')">
                                        <span>✓</span> Завершити тренування
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="pullups-today-sessions">
                                <!-- Сесії за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Віджимання -->
                    <div class="sub-tab-panel" id="pushups-content">
                        <div class="training-section">
                            <div class="training-plan-card">
                                <div class="training-plan-title">План віджимань (5 підходів)</div>
                                <div class="training-plan-sets" id="pushups-plan-sets"></div>
                                <div class="training-plan-note" id="pushups-plan-note"></div>
                                <div class="training-plan-progress" id="pushups-plan-progress"></div>
                                <div class="training-week-status" id="pushups-week-status"></div>
                            </div>
                            <div class="training-sets-form">
                                <h3 class="training-form-title">Новий підхід</h3>
                                <div class="training-form-row">
                                    <div class="training-form-group">
                                        <label class="field-label" for="pushups-reps">Кількість повторів</label>
                                        <input type="number" id="pushups-reps" min="1" max="100" placeholder="0">
                                    </div>
                                    <button class="btn-add-set" onclick="addSet('pushups')">+ Додати підхід</button>
                                    <button class="btn-add-set btn-add-set-plan" onclick="addNextPlannedSet('pushups')">+ Додати за планом</button>
                                </div>
                            </div>

                            <div class="training-current-session" id="pushups-current-session">
                                <h3 class="training-form-title">Поточна сесія</h3>
                                <div class="training-sets-list" id="pushups-sets-list">
                                    <!-- Підходи поточної сесії -->
                                </div>
                                <div class="training-session-actions" id="pushups-session-actions"
                                    style="display: none;">
                                    <button class="btn-timer btn-stop" onclick="finishSession('pushups')">
                                        <span>✓</span> Завершити тренування
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="pushups-today-sessions">
                                <!-- Сесії за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Історія -->
                    <div class="sub-tab-panel" id="training-history-content">
                        <div class="training-section">
                            <div class="training-history-filters">
                                <button class="filter-button active" data-filter="all"
                                    onclick="filterTrainingHistory('all')">Всі</button>
                                <button class="filter-button" data-filter="running"
                                    onclick="filterTrainingHistory('running')">Біг</button>
                                <button class="filter-button" data-filter="pullups"
                                    onclick="filterTrainingHistory('pullups')">Підтягування</button>
                                <button class="filter-button" data-filter="pushups"
                                    onclick="filterTrainingHistory('pushups')">Віджимання</button>
                            </div>

                            <div class="tab-panel-table">
                                <table class="data-table">
                                    <thead>
                                        <tr>
                                            <th class="col-date sortable" data-sort="date">
                                                <span class="th-label">Дата</span>
                                                <span class="sort-icon">↕</span>
                                            </th>
                                            <th class="col-category">
                                                <span class="th-label">Тип</span>
                                            </th>
                                            <th class="col-name">
                                                <span class="th-label">Результат</span>
                                            </th>
                                            <th class="col-actions"></th>
                                        </tr>
                                    </thead>
                                    <tbody id="training-history-tbody"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                        </div>
                    </div>

                    <div class="tab-panel" id="egds">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="egds-products">
                                <i class="ri-store-2-line sub-tab-icon"></i>
                                <span>Товари</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="egds-orders">
                                <i class="ri-shopping-bag-3-line sub-tab-icon"></i>
                                <span>Замовлення</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>
                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="egds-products-content">
                                <div id="egds-product-form-panel" class="custom-modal">
                                    <div class="custom-modal-content edit-modal-wide">
                                        <h3 class="custom-modal-title" id="egds-product-form-title">Новий товар</h3>
                                        <input type="hidden" id="egds-product-id">
                                        <div class="modal-form-grid">
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-name">Назва</label>
                                                <input type="text" id="egds-product-name" class="field-input"
                                                    placeholder="Назва товару..." maxlength="255">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-category">Категорія</label>
                                                <input type="text" id="egds-product-category" class="field-input"
                                                    placeholder="Напр. Смартфони" maxlength="100">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-price">Ціна</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-product-price"
                                                        class="field-input field-input-number" placeholder="0.00"
                                                        step="0.01" min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-price" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-add-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-price" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-stock">Залишок</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-product-stock"
                                                        class="field-input field-input-number" placeholder="0" step="1"
                                                        min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-stock" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-add-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-stock" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="custom-modal-actions">
                                            <button class="btn-secondary" onclick="cancelEgdsForms()">Скасувати</button>
                                            <button class="btn-danger"
                                                style="background: var(--text-main); color: var(--bg-app);"
                                                onclick="saveEgdsProduct()">Зберегти</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="name"><span
                                                        class="th-label">Назва</span></th>
                                                <th class="col-category sortable" data-sort="category"><span
                                                        class="th-label">Категорія</span></th>
                                                <th class="col-price sortable" data-sort="price"><span
                                                        class="th-label">Ціна</span></th>
                                                <th class="col-limit sortable" data-sort="stock_quantity"><span
                                                        class="th-label">Залишок</span></th>
                                                <th class="col-date sortable" data-sort="updated_at"><span
                                                        class="th-label">Оновлено</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="egds-products-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="egds-orders-content">
                                <div id="egds-order-form-panel" class="custom-modal">
                                    <div class="custom-modal-content edit-modal-wide">
                                        <h3 class="custom-modal-title" id="egds-order-form-title">Нове замовлення</h3>
                                        <input type="hidden" id="egds-order-id">
                                        <div class="modal-form-grid">
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-number">Номер замовлення</label>
                                                <input type="text" id="egds-order-number" class="field-input"
                                                    placeholder="ORD-2026-001" maxlength="50">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-customer-id">Клієнт</label>
                                                <div class="field-select-wrap">
                                                    <select id="egds-order-customer-id" class="field-select"></select>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-total">Сума</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-order-total"
                                                        class="field-input field-input-number" placeholder="0.00"
                                                        step="0.01" min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-order-total" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-add-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-order-total" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-status">Статус</label>
                                                <div class="field-select-wrap">
                                                    <select id="egds-order-status" class="field-select">
                                                        <option value="new">new</option>
                                                        <option value="processing">processing</option>
                                                        <option value="shipped">shipped</option>
                                                        <option value="delivered">delivered</option>
                                                        <option value="cancelled">cancelled</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="custom-modal-actions">
                                            <button class="btn-secondary" onclick="cancelEgdsForms()">Скасувати</button>
                                            <button class="btn-danger"
                                                style="background: var(--text-main); color: var(--bg-app);"
                                                onclick="saveEgdsOrder()">Зберегти</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="order_number"><span
                                                        class="th-label">№ замовлення</span></th>
                                                <th class="col-name sortable" data-sort="customer_name"><span
                                                        class="th-label">Клієнт</span></th>
                                                <th class="col-price sortable" data-sort="total_amount"><span
                                                        class="th-label">Сума</span></th>
                                                <th class="col-category sortable" data-sort="status"><span
                                                        class="th-label">Статус</span></th>
                                                <th class="col-date sortable" data-sort="created_at"><span
                                                        class="th-label">Створено</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="egds-orders-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-panel" id="goals">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="goals-current">
                                <i class="ri-focus-3-line sub-tab-icon"></i>
                                <span>Поточні цілі</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="goals-view-switcher" id="goals-view-switcher">
                                    <button type="button" class="goals-view-btn active" data-view="grid" title="Вид картками">
                                        <i class="ri-grid-fill"></i> <span>Картки</span>
                                    </button>
                                    <button type="button" class="goals-view-btn" data-view="table" title="Вид таблицею">
                                        <i class="ri-table-line"></i> <span>Таблиця</span>
                                    </button>
                                </div>
                                <button type="button" class="goals-select-all-btn" id="goals-select-all-btn" title="Виділити всі картки">
                                    <i class="ri-checkbox-multiple-line"></i>
                                    <span>Виділити всі</span>
                                </button>
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>
                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="goals-current-content">
                                <div class="goals-cards-grid" id="goals-cards-grid"></div>
                                <div class="tab-panel-table" id="goals-table-container" style="display: none;">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="title"><span
                                                        class="th-label">Назва</span></th>
                                                <th class="col-category sortable" data-sort="category"><span
                                                        class="th-label">Категорія</span></th>
                                                <th class="col-status sortable" data-sort="status"><span
                                                        class="th-label">Статус</span></th>
                                                <th class="col-limit sortable" data-sort="progress_percent"><span
                                                        class="th-label">Прогрес</span></th>
                                                <th class="col-date sortable" data-sort="target_at"><span
                                                        class="th-label">Дедлайн</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="goals-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="youtube">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="fancy-music">
                                <i class="ri-youtube-line sub-tab-icon"></i>
                                <span>Fancy Music</span>
                            </button>
                            <div class="tab-header-right">
                                <button class="stats-refresh-btn" id="youtube-sync-btn" title="Синхронізувати з YouTube">
                                    <i class="ri-refresh-line"></i>
                                    <span>Синхронізувати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="fancy-music-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="title">
                                                    <span class="th-label">Назва</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-type sortable" data-sort="video_type">
                                                    <span class="th-label">Тип</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-date sortable" data-sort="published_at">
                                                    <span class="th-label">Дата публікації</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="fancy-music-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="profile">
<div class="tab-panel-header">
                            <div class="tab-header-right"></div>
                    </div>

                        <div class="profile-content">
                            <input type="file" id="avatar-upload-input" style="display: none;" accept="image/*">
                            <section class="profile-hero">
                                <div class="profile-avatar" id="profile-avatar-container" aria-label="Фото профілю"
                                    onclick="document.getElementById('avatar-upload-input').click()" title="Натисніть для зміни фото">
                                    <img src="src/images/profile.png" alt="avatar" id="profile-avatar-img" onerror="this.onerror=null; this.src='src/images/profile.png';">
                                    <div class="avatar-overlay"><i class="ri-camera-line"></i></div>
                                </div>
                                <div class="profile-identity">
                                    <div class="profile-kicker">Профіль користувача</div>
                                    <h2 class="profile-display-name" id="profile-nickname">—</h2>
                                    <div class="profile-identity-meta">
                                        <span class="profile-chip">
                                            <i class="ri-user-line"></i>
                                            <span id="profile-username">—</span>
                                        </span>
                                        <span class="profile-chip">
                                            <i class="ri-shield-user-line"></i>
                                            <span id="profile-role">—</span>
                                        </span>
                                    </div>
                                </div>
                            </section>

                            <section class="profile-sections">
                                <div class="profile-section">
                                    <div class="profile-section-label">Створено</div>
                                    <div class="profile-section-value" id="profile-created">—</div>
                                </div>
                            </section>

                            <section class="profile-actions-card">
                                <div class="profile-section-label">Дії</div>
                                <div id="profile-actions">
                                    <button class="edit-profile-button" onclick="document.getElementById('avatar-upload-input').click()"
                                        title="Змінити фото профілю">
                                        <i class="ri-camera-line"></i>
                                        <span class="edit-text">Змінити аватарку</span>
                                    </button>
                                    <button class="edit-profile-button" onclick="showEditProfile()"
                                        title="Редагувати профіль">
                                        <span class="edit-icon">✏️</span>
                                        <span class="edit-text">Редагувати</span>
                                    </button>
                                    <button class="logout-button" onclick="handleLogout()" title="Вийти з системи">
                                        <span class="logout-icon">🚪</span>
                                        <span class="logout-text">Вийти</span>
                                    </button>
                                </div>
                            </section>
                        </div>

                        <div class="edit-profile-panel add-edit-project-panel legacy-modal" style="display: none;">
                            <div class="add-edit-project-panel-header">
                                <h3 class="add-edit-project-panel-title">Редагування профілю</h3>
                            </div>
                            <div class="add-edit-project-panel-content">
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-nickname">Нікнейм</label>
                                        <input type="text" id="edit-profile-nickname" placeholder="Як вас називати?..."
                                            maxlength="100">
                                    </div>
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-username">Логін</label>
                                        <input type="text" id="edit-profile-username"
                                            placeholder="Введіть новий логін..." maxlength="50">
                                    </div>
                                </div>
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-password">Новий пароль</label>
                                        <input type="password" id="edit-profile-password"
                                            placeholder="Введіть новий пароль..." maxlength="100">
                                    </div>
                                </div>
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-confirm-password">Підтвердження
                                            пароля</label>
                                        <input type="password" id="edit-profile-confirm-password"
                                            placeholder="Повторіть новий пароль..." maxlength="100">
                                    </div>
                                </div>
                            </div>
                            <div class="add-edit-project-panel-actions">
                                <button class="btn-save" title="Зберегти" onclick="updateProfile()">Зберегти</button>
                                <button class="btn-cancel" title="Скасувати" onclick="cancelEditProfile()">Скасувати</button>
                        </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="photo-reports">
<div class="tab-panel-header photo-reports-panel-header">
                            <div class="photo-reports-header-left">
                                <div class="sub-tab-button active is-static" style="cursor: default;">
                                    <i class="ri-gallery-line sub-tab-icon"></i>
                                    <span>Фотозвіти</span>
                                </div>
                            </div>
                            <div class="tab-header-right">
                                <button class="add-data-table-item" id="btn-generate-photo-report">
                                    <i class="ri-magic-line sub-tab-icon"></i>
                                    <span>Згенерувати новий звіт</span>
                                </button>
                            </div>
                    </div>

                        <div class="report-generator-box">
                            <div class="report-generator-controls">
                                <div class="report-type-selector">
                                    <span class="control-label">Обрати період:</span>
                                    <div class="segmented-control" id="report-type-segmented">
                                        <button class="segment-btn active" data-report-type="week">Тиждень</button>
                                        <button class="segment-btn" data-report-type="month">Місяць</button>
                                        <button class="segment-btn" data-report-type="year">Рік</button>
                                    </div>
                                </div>
                                <div class="report-actions-row">
                                    <button class="btn btn-secondary" id="btn-download-report-img" title="Завантажити картинку на пристрій">
                                        <i class="ri-download-2-line"></i> Завантажити PNG
                                    </button>
                                    <button class="btn btn-primary" id="btn-save-report-gallery" title="Зберегти звіт у галерею">
                                        <i class="ri-bookmark-3-line"></i> Зберегти в галерею
                                    </button>
                                </div>
                            </div>

                            <div class="report-preview-container">
                                <canvas id="photo-report-canvas" width="1200" height="675" style="display:none;"></canvas>
                                <div class="report-preview-wrapper" id="report-preview-wrapper">
                                    <img id="report-preview-img" alt="Прев'ю фотозвіту" src="">
                                    <div class="report-preview-spinner" id="report-preview-spinner">
                                        <i class="ri-loader-4-line bb-spin"></i> Генеруємо ваш підсумковий фотозвіт...
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="photo-gallery-section">
                            <div class="gallery-toolbar">
                                <div class="gallery-title">
                                    <h3><i class="ri-history-line"></i> Архів збережених фотозвітів</h3>
                                    <span class="gallery-count" id="gallery-count-badge">0 карт у галереї</span>
                                </div>
                                <div class="gallery-filter-chips" id="gallery-filter-chips">
                                    <button class="filter-chip active" data-gallery-filter="all">Усі</button>
                                    <button class="filter-chip" data-gallery-filter="week">Тижневі</button>
                                    <button class="filter-chip" data-gallery-filter="month">Місячні</button>
                                    <button class="filter-chip" data-gallery-filter="year">Річні</button>
                                </div>
                            </div>

                            <div id="photo-reports-gallery" class="photo-reports-gallery-grid">
                                <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження галереї...</div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-panel" id="security">
<div class="tab-panel-header">

                            <button class="sub-tab-button active is-static" type="button" aria-disabled="true" tabindex="-1">
                                <i class="ri-group-line sub-tab-icon"></i>
                                <span>Користувачі</span>
                            </button>

                            <button class="filter-button" data-tooltip="Фільтри">
                                <i class="ri-filter-3-line sub-tab-icon"></i>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>
                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>
                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="users-list-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="username"><span
                                                        class="th-label">Користувач</span><span
                                                        class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-status"><span class="th-label">Пароль</span></th>
                                                <th class="col-status sortable" data-sort="role"><span
                                                        class="th-label">Права
                                                        доступу</span><span class="sort-icon">↕</span></th>
                                                <th class="col-date sortable" data-sort="created_at"><span
                                                        class="th-label">Створено</span><span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="users-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                <!-- База знань -->
                <div id="notes" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active" data-sub-tab="notes-list">
                            <i class="ri-book-read-line sub-tab-icon"></i>
                            <span>Всі нотатки</span>
                        </button>

                        <div class="tab-header-right">
                            <div class="selected-data-table-item" style="display: none;">
                                <i class="ri-check-line sub-tab-icon"></i>
                                <span class="selected-data-table-item-badge">0</span>
                                <span class="selected-data-table-item-label">вибрано</span>
                            </div>

                            <div class="data-table-bulk-actions" style="display: none;">
                                <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                    <i class="ri-delete-bin-line"></i>
                                    <span>Видалити</span>
                                </button>
                            </div>

                            <button class="add-data-table-item" id="notes-add-btn" data-tooltip="Гаряча клавіша: N">
                                <i class="ri-add-line sub-tab-icon"></i>
                                <span>Додати</span>
                            </button>
                        </div>
                    </div>

                    <div class="sub-tab-content">
                        <div class="sub-tab-panel active" id="notes-list-content">
                            <div class="notes-container">
                                <!-- Sidebar -->
                                <div class="notes-sidebar">
                                    <div class="notes-sidebar-header">
                                        <div class="notes-search-wrapper">
                                            <i class="ri-search-line search-icon"></i>
                                            <input type="text" id="notes-search-input" placeholder="Пошук нотаток..." class="notes-search-input">
                                        </div>
                                        <button id="new-note-btn" class="notes-new-btn">
                                            <i class="ri-add-line"></i>
                                            <span>Створити</span>
                                        </button>
                                    </div>
                                    <div class="notes-list-wrapper">
                                        <ul id="notes-list" class="notes-list"></ul>
                                    </div>
                                </div>

                                <!-- Editor Workspace -->
                                <div class="notes-editor">
                                    <div id="notes-empty-state" class="notes-empty-state" style="display: none;">
                                        <div class="empty-state-icon"><i class="ri-draft-line"></i></div>
                                        <h3>Нотатку не обрано</h3>
                                        <p>Оберіть нотатку зі списку ліворуч або створіть нову</p>
                                        <button id="empty-new-note-btn" class="notes-new-btn">
                                            <i class="ri-add-line"></i> Створити нотатку
                                        </button>
                                    </div>

                                    <div id="notes-editor-inner" class="notes-editor-inner">
                                        <div class="notes-editor-toolbar">
                                            <div class="notes-meta-info">
                                                <span id="note-save-status" class="note-save-status"><i class="ri-checkbox-circle-line"></i> Збережено</span>
                                            </div>
                                            <div class="notes-actions">
                                                <button id="delete-note-btn" class="notes-btn-action btn-danger" title="Видалити">
                                                    <i class="ri-delete-bin-line"></i>
                                                    <span>Видалити</span>
                                                </button>
                                                <button id="save-note-btn" class="notes-btn-action btn-primary" title="Зберегти (Ctrl+S)">
                                                    <i class="ri-save-line"></i>
                                                    <span>Зберегти</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="notes-editor-canvas">
                                            <input type="text" id="note-title" class="note-title-input" placeholder="Заголовок нотатки..." autocomplete="off">
                                            <textarea id="note-content" class="note-content-textarea" placeholder="Почніть вводити текст нотатки (підтримується Markdown: # Заголовок, **жирний**, - списки)..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Трекер звичок -->
                <div id="habits" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active is-static" type="button" aria-disabled="true" tabindex="-1">
                            <i class="ri-calendar-check-line sub-tab-icon"></i>
                            <span>Мої звички</span>
                        </button>
                        <div class="tab-header-right">
                            <button id="add-habit-btn" class="add-data-table-item" onclick="window.openAddHabitModal && window.openAddHabitModal()">
                                <i class="ri-add-line sub-tab-icon"></i>
                                <span>Додати звичку</span>
                            </button>
                        </div>
                    </div>
                    <div id="habits-grid" class="habits-grid">
                        <!-- Звички рендеряться тут -->
                    </div>
                </div>

                <!-- Помодоро -->
                <div id="pomodoro" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active" data-sub-tab="pomodoro-timer">
                            <i class="ri-timer-line sub-tab-icon"></i>
                            <span>Таймер Помодоро</span>
                        </button>
                        <button class="sub-tab-button" data-sub-tab="pomodoro-stats">
                            <i class="ri-bar-chart-box-line sub-tab-icon"></i>
                            <span>Статистика сесій</span>
                        </button>

                        <div class="tab-header-right">
                            <button class="add-data-table-item" id="pomodoro-quick-start-btn">
                                <i class="ri-play-line sub-tab-icon"></i>
                                <span>Запустити 25хв</span>
                            </button>
                        </div>
                    </div>

                    <div class="sub-tab-content">
                        <div class="sub-tab-panel active" id="pomodoro-timer-content">
                            <div class="pomodoro-wrapper">
                                <div class="pomodoro-container">
                                    <!-- Mode Selector Pills -->
                                    <div class="pomodoro-modes">
                                        <button class="pomo-mode-btn active" data-mode="focus" data-time="25">
                                            <i class="ri-focus-3-line"></i>
                                            <span>25 хв Фокус</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="shortBreak" data-time="5">
                                            <i class="ri-cup-line"></i>
                                            <span>5 хв Перерва</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="longBreak" data-time="15">
                                            <i class="ri-rest-time-line"></i>
                                            <span>15 хв Відпочинок</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="deepWork" data-time="50">
                                            <i class="ri-flashlight-line"></i>
                                            <span>50 хв Глибока праця</span>
                                        </button>
                                    </div>

                                    <!-- Circular Timer Display -->
                                    <div class="pomodoro-circle-wrapper">
                                        <svg class="pomodoro-ring" width="300" height="300" viewBox="0 0 300 300">
                                            <defs>
                                                <linearGradient id="pomoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" stop-color="#3b82f6" />
                                                    <stop offset="100%" stop-color="#8b5cf6" />
                                                </linearGradient>
                                            </defs>
                                            <circle class="ring-bg" cx="150" cy="150" r="130" />
                                            <circle class="ring-progress" id="pomodoro-progress-circle" cx="150" cy="150" r="130" />
                                        </svg>

                                        <div class="pomodoro-timer-center">
                                            <span id="pomodoro-mode-label" class="pomodoro-mode-label">Фокус сесія</span>
                                            <h2 id="pomodoro-timer-display" class="pomodoro-timer-display">25:00</h2>
                                            <span id="pomodoro-status-hint" class="pomodoro-status-hint">Натисніть Старт для початку</span>
                                        </div>
                                    </div>

                                    <!-- Action Controls -->
                                    <div class="pomodoro-controls">
                                        <button id="pomodoro-start-btn" class="pomodoro-btn pomodoro-btn-primary">
                                            <i class="ri-play-fill"></i> Старт
                                        </button>
                                        <button id="pomodoro-pause-btn" class="pomodoro-btn pomodoro-btn-pause" style="display: none;">
                                            <i class="ri-pause-fill"></i> Пауза
                                        </button>
                                        <button id="pomodoro-add5-btn" class="pomodoro-btn pomodoro-btn-secondary" title="Додати 5 хвилин">
                                            <i class="ri-add-line"></i> +5 хв
                                        </button>
                                        <button id="pomodoro-reset-btn" class="pomodoro-btn pomodoro-btn-secondary" title="Скинути таймер">
                                            <i class="ri-refresh-line"></i>
                                        </button>
                                    </div>

                                    <!-- Daily Summary Stats -->
                                    <div class="pomodoro-stats-cards">
                                        <div class="pomo-stat-card">
                                            <i class="ri-fire-line stat-icon"></i>
                                            <div class="stat-info">
                                                <span class="stat-val" id="pomo-completed-count">0</span>
                                                <span class="stat-lbl">Сесій сьогодні</span>
                                            </div>
                                        </div>
                                        <div class="pomo-stat-card">
                                            <i class="ri-time-line stat-icon"></i>
                                            <div class="stat-info">
                                                <span class="stat-val" id="pomo-completed-minutes">0 хв</span>
                                                <span class="stat-lbl">Час у фокусі</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="sub-tab-panel" id="pomodoro-stats-content">
                            <div class="data-table-container">
                                <table class="data-table">
                                    <thead>
                                        <tr>
                                            <th class="col-date sortable" data-sort="completed_at">Дата та час</th>
                                            <th class="col-limit">Тривалість</th>
                                            <th class="col-name">Нотатка / Опис</th>
                                        </tr>
                                    </thead>
                                    <tbody id="pomodoro-stats-table-tbody"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                </div> <!-- .tab-content -->
            </div> <!-- .tab-container -->
        </main> <!-- .main-content -->
    </div> <!-- .app-layout -->

    <!-- Modal for adding a new project -->
    <div id="add-project-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Додати проект</h3>

            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="project-modal-name">Назва</label>
                    <input type="text" id="project-modal-name" class="field-input" placeholder="Введіть назву..."
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="project-modal-status">Статус</label>
                    <select id="project-modal-status" class="field-select">
                        <option value="Активний">Активний</option>
                        <option value="Завершений">Завершений</option>
                        <option value="В розробці">В розробці</option>
                    </select>
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelProjectPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveProject()">Зберегти</button>
            </div>
        </div>
    </div>

    <!-- Modal for editing a project -->
    <div id="edit-project-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагувати проект</h3>

            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="edit-project-modal-name">Назва</label>
                    <input type="text" id="edit-project-modal-name" class="field-input" placeholder="Назва..."
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-status">Статус</label>
                    <select id="edit-project-modal-status" class="field-select">
                        <option value="Активний">Активний</option>
                        <option value="Завершений">Завершений</option>
                        <option value="В розробці">В розробці</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-date">Дата та час</label>
                    <input type="text" id="edit-project-modal-date" class="field-input date-time-input"
                        placeholder="ДД.ММ.РРРР ГГ:ХХ" maxlength="16" inputmode="numeric" autocomplete="off"
                        pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditProjectPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateProject()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <!-- Modals for Expense Management -->
    <div class="add-expense-panel add-edit-project-panel legacy-modal" style="display: none;">
        <div class="add-edit-project-panel-header">
            <h3 class="add-edit-project-panel-title">Нова витрата</h3>
        </div>
        <div class="add-edit-project-panel-content">
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-date">Дата</label>
                    <input type="text" id="expense-date" class="date-time-input"
                        placeholder="ДД.ММ.РРРР" maxlength="10" inputmode="numeric"
                        autocomplete="off">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-type">Тип витрати</label>
                    <div class="custom-select" data-input-id="expense-type">
                        <button type="button" class="custom-select-toggle">Магазин</button>
                        <ul class="custom-select-menu" role="listbox">
                            <li class="custom-select-option is-selected" role="option"
                                aria-selected="true" data-value="Магазин">Магазин</li>
                            <li class="custom-select-option" role="option"
                                data-value="Транспорт">Транспорт</li>
                            <li class="custom-select-option" role="option"
                                data-value="Харчування">Харчування</li>
                            <li class="custom-select-option" role="option"
                                data-value="Розваги">Розваги</li>
                            <li class="custom-select-option" role="option"
                                data-value="Комунальні">Комунальні</li>
                            <li class="custom-select-option" role="option"
                                data-value="Здоров'я">Здоров'я</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інше">Інше</li>
                        </ul>
                        <input type="hidden" id="expense-type" value="Магазин">
                    </div>
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-store">Магазин / Місце</label>
                    <input type="text" id="expense-store" placeholder="Напр. АТБ, Сільпо..."
                        maxlength="255">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-amount">Сума</label>
                    <input type="number" id="expense-amount" placeholder="0.00" step="0.01">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-currency">Валюта</label>
                    <input type="text" id="expense-currency" placeholder="UAH"
                        maxlength="10" value="UAH">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-description">Опис</label>
                    <input type="text" id="expense-description"
                        placeholder="Додаткова інформація..." maxlength="500">
                </div>
            </div>
        </div>
        <div class="add-edit-project-panel-actions">
            <button class="btn-save" title="Готово" onclick="saveExpense()">Зберегти</button>
            <button class="btn-cancel" title="Скасувати"
                onclick="cancelExpensePanel()">Скасувати</button>
        </div>
    </div>

    <div class="edit-expense-panel add-edit-project-panel legacy-modal" style="display: none;">
        <div class="add-edit-project-panel-header">
            <h3 class="add-edit-project-panel-title">Редагування витрати</h3>
        </div>
        <div class="add-edit-project-panel-content">
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-date">Дата</label>
                    <input type="text" id="edit-expense-date" class="date-time-input"
                        placeholder="ДД.ММ.РРРР" maxlength="10" inputmode="numeric"
                        autocomplete="off">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-type">Тип витрати</label>
                    <div class="custom-select" data-input-id="edit-expense-type">
                        <button type="button" class="custom-select-toggle">Магазин</button>
                        <ul class="custom-select-menu" role="listbox">
                            <li class="custom-select-option is-selected" role="option"
                                aria-selected="true" data-value="Магазин">Магазин</li>
                            <li class="custom-select-option" role="option"
                                data-value="Транспорт">Транспорт</li>
                            <li class="custom-select-option" role="option"
                                data-value="Харчування">Харчування</li>
                            <li class="custom-select-option" role="option"
                                data-value="Розваги">Розваги</li>
                            <li class="custom-select-option" role="option"
                                data-value="Комунальні">Комунальні</li>
                            <li class="custom-select-option" role="option"
                                data-value="Здоров'я">Здоров'я</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інше">Інше</li>
                        </ul>
                        <input type="hidden" id="edit-expense-type" value="Магазин">
                    </div>
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-store">Магазин / Місце</label>
                    <input type="text" id="edit-expense-store"
                        placeholder="Напр. АТБ, Сільпо..." maxlength="255">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-amount">Сума</label>
                    <input type="number" id="edit-expense-amount" placeholder="0.00"
                        step="0.01">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-currency">Валюта</label>
                    <input type="text" id="edit-expense-currency" placeholder="UAH"
                        maxlength="10">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-description">Опис</label>
                    <input type="text" id="edit-expense-description"
                        placeholder="Додаткова інформація..." maxlength="500">
                </div>
            </div>
        </div>
        <div class="add-edit-project-panel-actions">
            <button class="btn-save" title="Зберегти" onclick="updateExpense()">Зберегти</button>
            <button class="btn-cancel" title="Скасувати"
                onclick="cancelEditExpensePanel()">Скасувати</button>
        </div>
    </div>

    <!-- Modal for adding a new task -->
    <div id="add-task-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Додати завдання</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label">Завдання</label>
                    <input type="text" id="task-title" class="field-input" placeholder="Що потрібно зробити?" maxlength="100">
                    <div class="field-meta">Макс. 100 символів</div>
                </div>

                <div class="form-group">
                    <label class="field-label">Дата</label>
                    <div class="date-field-wrap task-date-field-wrap">
                        <input type="text" id="task-date" class="field-input task-date-input" data-no-ghost="1"
                            placeholder="дд.мм.рррр" maxlength="10" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d$">
                        <button type="button" class="date-today-trigger" data-target-date-input="task-date"
                            aria-label="Встановити сьогоднішню дату">Сьогодні</button>
                        <div class="date-shift-controls" aria-label="Зміна дати на 1 день">
                            <button type="button" class="date-shift-trigger date-shift-up" data-shift-days="1"
                                data-target-date-input="task-date" aria-label="Збільшити дату на 1 день">
                                <i class="ri-add-line"></i>
                            </button>
                            <button type="button" class="date-shift-trigger date-shift-down" data-shift-days="-1"
                                data-target-date-input="task-date" aria-label="Зменшити дату на 1 день">
                                <i class="ri-subtract-line"></i>
                            </button>
                        </div>
                        <button type="button" class="date-picker-trigger" data-target-input="task-date"
                            data-target-time-input="task-time" aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="date" class="native-date-picker" data-for-input="task-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Час (необов'язково)</label>
                    <input type="text" id="task-time" class="field-input task-time-input" placeholder="гг:хв"
                        maxlength="5" inputmode="numeric" autocomplete="off"
                        pattern="^([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                </div>

                <div class="form-group">
                    <label class="field-label">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="task-category" class="field-select">
                            <option value="">Немає</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Розваги">Розваги</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Період</label>
                    <div class="field-select-wrap">
                        <select id="task-period" class="field-select">
                            <option value="">Немає</option>
                            <option value="09:00-12:00">Ранок (09:00-12:00)</option>
                            <option value="12:00-15:00">День (12:00-15:00)</option>
                            <option value="15:00-18:00">Вечір (15:00-18:00)</option>
                            <option value="18:00-21:00">Пізній вечір (18:00-21:00)</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Ліміт (хв)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="task-limit" class="field-input field-input-number" placeholder="60">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="task-limit"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-add-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="task-limit"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Повторення</label>
                    <div class="field-select-wrap">
                        <select id="task-repeat-type" class="field-select">
                            <option value="none">Не повторювати</option>
                            <option value="daily">Кожен день</option>
                            <option value="weekdays">Робочі дні (Пн-Пт)</option>
                            <option value="custom">Вибір днів тижня</option>
                        </select>
                    </div>
                </div>

                <div class="form-group full-width task-repeat-days-group" id="task-repeat-days-wrap" style="display: none;">
                    <label class="field-label">Дні тижня</label>
                    <div class="task-repeat-days-picker" id="task-repeat-days-picker">
                        <button type="button" class="repeat-day-btn" data-day="1">Пн</button>
                        <button type="button" class="repeat-day-btn" data-day="2">Вт</button>
                        <button type="button" class="repeat-day-btn" data-day="3">Ср</button>
                        <button type="button" class="repeat-day-btn" data-day="4">Чт</button>
                        <button type="button" class="repeat-day-btn" data-day="5">Пт</button>
                        <button type="button" class="repeat-day-btn" data-day="6">Сб</button>
                        <button type="button" class="repeat-day-btn" data-day="7">Нд</button>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Опис</label>
                    <textarea id="task-desc" class="field-textarea" rows="3"
                        placeholder="Додаткові деталі..."></textarea>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Теги (через пробіл)</label>
                    <input type="text" id="task-tags" class="field-input" placeholder="#терміново #важливо">
                </div>

                <div class="form-group full-width checkbox-group" id="task-auto-complete-group" style="display:none;">
                    <input type="checkbox" id="task-auto-complete">
                    <label for="task-auto-complete">Автозавершення після ліміту</label>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelTaskPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveTask()">Зберегти</button>
            </div>
        </div>
    </div>

    <!-- Modal for editing a task -->
    <div id="edit-task-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагувати завдання</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label">Завдання</label>
                    <input type="text" id="edit-task-title" class="field-input" maxlength="100">
                    <div class="field-meta">Макс. 100 символів</div>
                </div>

                <div class="form-group">
                    <label class="field-label">Дата</label>
                    <div class="date-field-wrap task-date-field-wrap">
                        <input type="text" id="edit-task-date" class="field-input task-date-input" data-no-ghost="1"
                            placeholder="дд.мм.рррр" maxlength="10" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d$">
                        <button type="button" class="date-today-trigger" data-target-date-input="edit-task-date"
                            aria-label="Встановити сьогоднішню дату">Сьогодні</button>
                        <div class="date-shift-controls" aria-label="Зміна дати на 1 день">
                            <button type="button" class="date-shift-trigger date-shift-up" data-shift-days="1"
                                data-target-date-input="edit-task-date" aria-label="Збільшити дату на 1 день">
                                <i class="ri-add-line"></i>
                            </button>
                            <button type="button" class="date-shift-trigger date-shift-down" data-shift-days="-1"
                                data-target-date-input="edit-task-date" aria-label="Зменшити дату на 1 день">
                                <i class="ri-subtract-line"></i>
                            </button>
                        </div>
                        <button type="button" class="date-picker-trigger" data-target-input="edit-task-date"
                            data-target-time-input="edit-task-time" aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="date" class="native-date-picker" data-for-input="edit-task-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Час (необов'язково)</label>
                    <input type="text" id="edit-task-time" class="field-input task-time-input" placeholder="гг:хв"
                        maxlength="5" inputmode="numeric" autocomplete="off"
                        pattern="^([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                </div>

                <div class="form-group">
                    <label class="field-label">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-category" class="field-select">
                            <option value="">Немає</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Розваги">Розваги</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Період</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-period" class="field-select">
                            <option value="">Немає</option>
                            <option value="09:00-12:00">Ранок (09:00-12:00)</option>
                            <option value="12:00-15:00">День (12:00-15:00)</option>
                            <option value="15:00-18:00">Вечір (15:00-18:00)</option>
                            <option value="18:00-21:00">Пізній вечір (18:00-21:00)</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Повторення</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-repeat-type" class="field-select">
                            <option value="none">Не повторювати</option>
                            <option value="daily">Кожен день</option>
                            <option value="weekdays">Робочі дні (Пн-Пт)</option>
                            <option value="custom">Вибір днів тижня</option>
                        </select>
                    </div>
                </div>

                <div class="form-group full-width task-repeat-days-group" id="edit-task-repeat-days-wrap" style="display: none;">
                    <label class="field-label">Дні тижня</label>
                    <div class="task-repeat-days-picker" id="edit-task-repeat-days-picker">
                        <button type="button" class="repeat-day-btn" data-day="1">Пн</button>
                        <button type="button" class="repeat-day-btn" data-day="2">Вт</button>
                        <button type="button" class="repeat-day-btn" data-day="3">Ср</button>
                        <button type="button" class="repeat-day-btn" data-day="4">Чт</button>
                        <button type="button" class="repeat-day-btn" data-day="5">Пт</button>
                        <button type="button" class="repeat-day-btn" data-day="6">Сб</button>
                        <button type="button" class="repeat-day-btn" data-day="7">Нд</button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Ліміт (хв)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="edit-task-limit" class="field-input field-input-number">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="edit-task-limit"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-add-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="edit-task-limit"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Опис</label>
                    <textarea id="edit-task-desc" class="field-textarea" rows="3"></textarea>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Теги (через пробіл)</label>
                    <input type="text" id="edit-task-tags" class="field-input">
                </div>

                <div id="edit-task-auto-complete-group" class="form-group full-width checkbox-group"
                    style="display:none;">
                    <input type="checkbox" id="edit-task-auto-complete">
                    <label for="edit-task-auto-complete">Автозавершення після ліміту</label>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditTaskPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateTask()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <div id="add-user-modal" class="custom-modal add-user-panel">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Новий користувач</h3>
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="user-username">Користувач</label>
                    <input type="text" id="user-username" class="field-input" placeholder="Введіть логін..." maxlength="50">
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="user-password">Пароль</label>
                    <input type="password" id="user-password" class="field-input" placeholder="Введіть пароль..." maxlength="100">
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="user-role">Права доступу</label>
                    <div class="field-select-wrap">
                        <select id="user-role" class="field-select">
                            <option value="admin">Адміністратор</option>
                            <option value="user" selected>Користувач</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelUserPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);" onclick="saveUser()">Зберегти</button>
            </div>
        </div>
    </div>

    <div id="edit-user-modal" class="custom-modal edit-user-panel">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагування користувача</h3>
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="edit-user-username">Користувач</label>
                    <input type="text" id="edit-user-username" class="field-input" placeholder="Логін..." maxlength="50">
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="edit-user-password">Пароль</label>
                    <input type="password" id="edit-user-password" class="field-input" placeholder="Новий пароль (необов'язково)" maxlength="100">
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="edit-user-role">Права доступу</label>
                    <div class="field-select-wrap">
                        <select id="edit-user-role" class="field-select">
                            <option value="admin">Адміністратор</option>
                            <option value="user" selected>Користувач</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditUserPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);" onclick="updateUser()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <div id="custom-confirm" class="custom-modal">
        <div class="custom-modal-content">
            <h3 class="custom-modal-title">Підтвердження</h3>
            <p id="custom-confirm-message" class="custom-modal-message"></p>
            <div class="custom-modal-actions">
                <button id="custom-confirm-no" class="btn-secondary">Ні</button>
                <button id="custom-confirm-yes" class="btn-danger">Так, видалити</button>
            </div>
        </div>
    </div>

    <div id="add-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Додати ціль</h3>
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="goal-title">Назва цілі</label>
                    <input type="text" id="goal-title" class="field-input" placeholder="Наприклад: Купівля мотоцикла Yamaha R6"
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-type">Тип цілі</label>
                    <div class="field-select-wrap">
                        <select id="goal-type" class="field-select">
                            <option value="general">Звичайна ціль</option>
                            <option value="financial">Матеріальна / Накопичення коштів</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-category">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="goal-category" class="field-select">
                            <option value="Покупки">Покупки</option>
                            <option value="Фінанси">Фінанси</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Здоров'я">Здоров'я</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="goal-status" class="field-select">
                            <option value="Планується">Планується</option>
                            <option value="В процесі">В процесі</option>
                            <option value="Досягнуто">Досягнуто</option>
                            <option value="Відкладено">Відкладено</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-target-date">Дедлайн</label>
                    <div class="date-field-wrap">
                        <input type="text" id="goal-target-date" class="field-input date-time-input"
                            placeholder="дд.мм.рррр гг:хв" maxlength="16" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                        <button type="button" class="date-picker-trigger" data-target-input="goal-target-date"
                            aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="datetime-local" class="native-date-picker" data-for-input="goal-target-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <!-- Блок фінансових цілей -->
                <div id="goal-financial-fields" class="form-group full-width goal-financial-block" style="display: none;">
                    <div class="modal-form-grid" style="grid-template-columns: 1fr 1fr 100px;">
                        <div class="form-group">
                            <label class="field-label" for="goal-target-amount">Цільова сума</label>
                            <input type="number" id="goal-target-amount" class="field-input" placeholder="100000" step="100" min="0">
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="goal-current-amount">Накопичено наразі</label>
                            <input type="number" id="goal-current-amount" class="field-input" placeholder="0" step="100" min="0">
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="goal-currency">Валюта</label>
                            <div class="field-select-wrap">
                                <select id="goal-currency" class="field-select">
                                    <option value="грн">грн</option>
                                    <option value="$">$</option>
                                    <option value="€">€</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 12px;">
                        <label class="field-label" for="goal-image-url">Зображення цілі (URL або пресет)</label>
                        <input type="text" id="goal-image-url" class="field-input" placeholder="https://images.unsplash.com/...">
                        <div class="goal-image-presets">
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=800&q=80">🏍️ Мотоцикл</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80">🚗 Авто</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80">🏠 Будинок</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80">✈️ Подорож</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80">💻 Техніка</button>
                        </div>
                    </div>
                </div>

                <div class="form-group" id="goal-progress-wrap">
                    <label class="field-label" for="goal-progress">Прогрес (%)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="goal-progress" class="field-input field-input-number" min="0" max="100"
                            step="1" value="0">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="goal-progress"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-add-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="goal-progress"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="goal-description">Опис</label>
                    <textarea id="goal-description" class="field-textarea" rows="3"
                        placeholder="Коротко опишіть ціль..."></textarea>
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelAddGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveGoal()">Зберегти</button>
            </div>
        </div>
    </div>

    <div id="edit-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагувати ціль</h3>
            <input type="hidden" id="edit-goal-id">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="edit-goal-title">Назва цілі</label>
                    <input type="text" id="edit-goal-title" class="field-input" maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-type">Тип цілі</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-type" class="field-select">
                            <option value="general">Звичайна ціль</option>
                            <option value="financial">Матеріальна / Накопичення коштів</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-category">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-category" class="field-select">
                            <option value="Покупки">Покупки</option>
                            <option value="Фінанси">Фінанси</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Здоров'я">Здоров'я</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-status" class="field-select">
                            <option value="Планується">Планується</option>
                            <option value="В процесі">В процесі</option>
                            <option value="Досягнуто">Досягнуто</option>
                            <option value="Відкладено">Відкладено</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-target-date">Дедлайн</label>
                    <div class="date-field-wrap">
                        <input type="text" id="edit-goal-target-date" class="field-input date-time-input"
                            placeholder="дд.мм.рррр гг:хв" maxlength="16" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                        <button type="button" class="date-picker-trigger" data-target-input="edit-goal-target-date"
                            aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="datetime-local" class="native-date-picker" data-for-input="edit-goal-target-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <!-- Блок фінансових цілей -->
                <div id="edit-goal-financial-fields" class="form-group full-width goal-financial-block" style="display: none;">
                    <div class="modal-form-grid" style="grid-template-columns: 1fr 1fr 100px;">
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-target-amount">Цільова сума</label>
                            <input type="number" id="edit-goal-target-amount" class="field-input" placeholder="100000" step="100" min="0">
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-current-amount">Накопичено наразі</label>
                            <input type="number" id="edit-goal-current-amount" class="field-input" placeholder="0" step="100" min="0">
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-currency">Валюта</label>
                            <div class="field-select-wrap">
                                <select id="edit-goal-currency" class="field-select">
                                    <option value="грн">грн</option>
                                    <option value="$">$</option>
                                    <option value="€">€</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 12px;">
                        <label class="field-label" for="edit-goal-image-url">Зображення цілі (URL або пресет)</label>
                        <input type="text" id="edit-goal-image-url" class="field-input" placeholder="https://images.unsplash.com/...">
                        <div class="goal-image-presets">
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=800&q=80">🏍️ Мотоцикл</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80">🚗 Авто</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80">🏠 Будинок</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80">✈️ Подорож</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80">💻 Техніка</button>
                        </div>
                    </div>
                </div>

                <div class="form-group" id="edit-goal-progress-wrap">
                    <label class="field-label" for="edit-goal-progress">Прогрес (%)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="edit-goal-progress" class="field-input field-input-number" min="0"
                            max="100" step="1">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="edit-goal-progress"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-add-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="edit-goal-progress"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-subtract-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="edit-goal-description">Опис</label>
                    <textarea id="edit-goal-description" class="field-textarea" rows="3"></textarea>
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateGoal()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <!-- Модальне вікно швидкого поповнення цілі -->
    <div id="deposit-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-small">
            <h3 class="custom-modal-title"><i class="ri-wallet-3-line"></i> Поповнити ціль</h3>
            <input type="hidden" id="deposit-goal-id">
            <div class="modal-form-grid">
                <div class="form-group full-width" style="text-align: center; margin-bottom: 8px;">
                    <div id="deposit-goal-name" style="font-size: 16px; font-weight: 700; color: var(--text-title);"></div>
                    <div id="deposit-goal-info" style="font-size: 13px; color: var(--text-muted); margin-top: 4px;"></div>
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="deposit-amount-input">Сума поповнення (+)</label>
                    <input type="number" id="deposit-amount-input" class="field-input" placeholder="Наприклад: 5000" step="100" min="1">
                </div>
            </div>
            <div class="custom-modal-actions" style="margin-top: 16px;">
                <button class="btn-secondary" onclick="cancelDepositGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: #3b82f6; color: #fff;" onclick="saveDepositGoal()">Поповнити</button>
            </div>
        </div>
    </div>

    <!-- Модальне вікно створення нової звички -->
    <div id="add-habit-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-small">
            <h3 class="custom-modal-title"><i class="ri-calendar-check-line"></i> Створити нову звичку</h3>
            <div class="modal-form-grid" style="grid-template-columns: 1fr; gap: 16px;">
                <div class="form-group">
                    <label class="field-label" for="habit-name-input">Назва звички *</label>
                    <input type="text" id="habit-name-input" class="field-input" placeholder="Наприклад: Пити 2л води, Читання 20хв..." autocomplete="off">
                </div>
                <div class="form-group">
                    <label class="field-label" for="habit-desc-input">Опис (необов'язково)</label>
                    <input type="text" id="habit-desc-input" class="field-input" placeholder="Короткий опис або ціль..." autocomplete="off">
                </div>
                <div class="form-group">
                    <label class="field-label">Колір акценту</label>
                    <div style="display: flex; gap: 12px; align-items: center; margin-top: 6px;">
                        <input type="color" id="habit-color-input" value="#10b981" style="width: 44px; height: 38px; border: none; background: transparent; cursor: pointer;">
                        <span style="font-size: 12px; color: var(--text-dim);">Оберіть колір для картки та індикатора</span>
                    </div>
                </div>
            </div>
            <div class="custom-modal-actions" style="margin-top: 20px;">
                <button type="button" class="btn-secondary" id="add-habit-cancel-btn" onclick="window.closeAddHabitModal && window.closeAddHabitModal()">Скасувати</button>
                <button type="button" class="btn-danger" style="background: #10b981; color: #fff;" id="add-habit-save-btn" onclick="window.saveHabitFromModal && window.saveHabitFromModal()">Створити звичку</button>
            </div>
        </div>
    </div>

    <script type="module" src="/src/js/main.ts"></script>
</body>

</html>
